export const URL = "staff/api/";
export const IMAGE_URL = "staff/api/tmp/";
export const TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhZG1pbl9pZCI6IjUiLCJuYW1lIjoibWVsYW50aXMiLCJlbWFpbCI6ImlsZXRpc2ltQG1lbGFudGlzYmlsaXNpbS5jb20udHIiLCJwYXNzIjoiTW0yMDE5Zm5zLiIsImF1dGgiOiJzdGFmZiJ9.18uW3sZ2l7TOblfgyUqBWaf63jH3e5G1MzX8a5ml7PU";
